import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

interface PageHeaderProps {
  title: string
  subtitle?: string
  /** Volitelné "i" s vysvětlením výpočtu/pravidel hned za titulkem (InfoHint). */
  info?: ReactNode
  actions?: ReactNode
}

/** Hlavička stránky fáze: titulek (+ volitelný popisek) vlevo, akce vpravo. */
export function PageHeader({ title, subtitle, info, actions }: PageHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h5">{title}</Typography>
          {info}
        </Box>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions}
    </Box>
  )
}
